import React from 'react'
import AppWrapper from '../AppWrapper'

function Sandbox() {
	return <AppWrapper />
}

export default Sandbox
